/* ============================================================
   Stelvio Returns Portal - GUIDA AGLI STEP (interattiva).

   QUANDO COMPARE: solo DOPO che il cliente ha trovato il suo
   ordine (numero + email). Nella schermata iniziale resta
   nascosta: li' servono due campi e un bottone, non una guida
   a quattro passaggi che allunga la pagina prima ancora di
   sapere se l'ordine e' valido. Da step 2 in poi invece la
   guida e' utile: dice cosa succede dopo la conferma, chi paga
   la spedizione e quando arriva il rimborso.

   DOVE: colonna laterale su desktop (sticky mentre si scorre la
   lista articoli), blocco sopra il form sotto i 900px.

   INTERATTIVITA': osserva il DOM del portale con un
   MutationObserver e capisce da sola a che punto e' il cliente,
   senza che returns-portal.js debba notificarla. Mappa:
     .sc-returns-form    -> step 1 (trova ordine)  -> NASCOSTA
     .sc-returns-items   -> step 2 (scegli)
     .sc-returns-sumlist -> step 2 (riepilogo)
     .sc-returns-casenum -> step 3 (richiesta inviata)
   Gli step passati diventano spuntati, quello corrente e' pieno
   e in evidenza, i futuri restano tenui.

   Autonomo: testi propri, nessuna dipendenza dall'ordine di
   caricamento degli altri file.
   REGOLA: niente backslash in questo file (upload via GraphQL).
   ============================================================ */
(function () {
  var GUIDE = {
    it: {
      title: 'Come funziona',
      steps: [
        { t: 'Trova il tuo ordine', d: 'Bastano il numero d’ordine e la email dell’acquisto. Nessun account da creare.' },
        { t: 'Scegli cosa fare', d: 'Per ogni capo: rimborso oppure cambio di taglia o colore. Il cambio è immediato e senza costi aggiuntivi.' },
        { t: 'Spedisci il reso', d: 'Il cambio è sempre gratuito: da Svizzera e Unione Europea ti inviamo noi l’etichetta prepagata. Per i rimborsi la spedizione è a tuo carico: nostra etichetta (costo trattenuto dal rimborso) oppure spedisci tu.' },
        { t: 'Rimborso o nuovo capo', d: 'Appena il pacco arriva in magazzino spediamo il cambio, oppure emettiamo il rimborso entro 10-14 giorni.' }
      ],
      help_q: 'Hai bisogno di aiuto?',
      help_mail: 'Scrivici a sales@stelviocollection.com',
      help_faq: 'Leggi le domande frequenti'
    },
    en: {
      title: 'How it works',
      steps: [
        { t: 'Find your order', d: 'All you need is your order number and the email used to buy. No account required.' },
        { t: 'Choose what to do', d: 'For each item: a refund, or a size or colour exchange. Exchanges are confirmed straight away, at no extra cost.' },
        { t: 'Ship it back', d: 'Exchanges are always free: from Switzerland and the European Union we email you the prepaid label. For refunds, return shipping is at your expense: use our label (cost deducted from your refund) or ship it yourself.' },
        { t: 'Refund or new item', d: 'As soon as the parcel reaches our warehouse we ship the exchange, or issue the refund within 10-14 days.' }
      ],
      help_q: 'Need a hand?',
      help_mail: 'Email us at sales@stelviocollection.com',
      help_faq: 'Read the frequently asked questions'
    },
    de: {
      title: 'So funktioniert es',
      steps: [
        { t: 'Bestellung finden', d: 'Du brauchst nur die Bestellnummer und die E-Mail des Kaufs. Kein Konto nötig.' },
        { t: 'Wähle dein Vorgehen', d: 'Pro Artikel: Rückerstattung oder Umtausch von Größe oder Farbe. Der Umtausch wird sofort bestätigt, ohne Aufpreis.' },
        { t: 'Paket zurücksenden', d: 'Der Umtausch ist immer kostenlos: Aus der Schweiz und der EU senden wir dir das frankierte Etikett per E-Mail. Bei Erstattungen trägst du die Rücksendekosten: unser Etikett (Kosten werden von der Erstattung abgezogen) oder du verschickst selbst.' },
        { t: 'Rückerstattung oder neuer Artikel', d: 'Sobald das Paket im Lager ankommt, versenden wir den Umtausch oder erstatten innerhalb von 10-14 Tagen.' }
      ],
      help_q: 'Brauchst du Hilfe?',
      help_mail: 'Schreib uns an sales@stelviocollection.com',
      help_faq: 'Häufige Fragen lesen'
    }
  };

  var MAIL = 'sales@stelviocollection.com';

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  // Deduce lo step corrente da cosa il portale ha renderizzato.
  function currentStep() {
    if (document.querySelector('.sc-returns-casenum')) return 3;
    if (document.querySelector('.sc-returns-sumlist')) return 2;
    if (document.querySelector('.sc-returns-items')) return 2;
    if (document.querySelector('.sc-returns-form')) return 1;
    return 1;
  }

  function render(root) {
    var active = currentStep();

    // Step 1 (ricerca ordine): guida nascosta, la schermata resta pulita.
    if (active <= 1) {
      root.innerHTML = '';
      root.style.display = 'none';
      return;
    }
    root.style.display = '';

    var lang = (root.dataset.locale || 'en').slice(0, 2).toLowerCase();
    var g = GUIDE[lang] || GUIDE.en;

    root.innerHTML = '';
    root.appendChild(el('div', 'sc-guide-title', g.title));

    var list = el('ol', 'sc-guide-list');
    g.steps.forEach(function (s, i) {
      var n = i + 1;
      var li = el('li', 'sc-guide-step');
      if (n < active) li.className += ' sc-done';
      else if (n === active) li.className += ' sc-current';
      else li.className += ' sc-todo';

      var num = el('span', 'sc-guide-num');
      if (n < active) {
        num.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 13l4 4L19 7"></path></svg>';
      } else {
        num.textContent = String(n);
      }
      li.appendChild(num);

      var body = el('div', 'sc-guide-body');
      body.appendChild(el('div', 'sc-guide-steptitle', s.t));
      body.appendChild(el('div', 'sc-guide-stepdesc', s.d));
      li.appendChild(body);
      list.appendChild(li);
    });
    root.appendChild(list);

    var help = el('div', 'sc-guide-help');
    help.appendChild(el('div', 'sc-guide-helpq', g.help_q));

    var a1 = el('a', 'sc-guide-link', g.help_mail);
    a1.href = 'mailto:' + MAIL;
    help.appendChild(a1);

    var a2 = el('a', 'sc-guide-link', g.help_faq);
    a2.href = '/pages/faq';
    help.appendChild(a2);

    root.appendChild(help);
  }

  function boot() {
    var roots = document.querySelectorAll('.sc-returns-guide');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      render(root);
      if (!root.dataset.scWatch) {
        root.dataset.scWatch = '1';
        var box = document.querySelector('.sc-returns-box');
        if (box && window.MutationObserver) {
          (function (r) {
            var last = currentStep();
            var obs = new MutationObserver(function () {
              var now = currentStep();
              if (now !== last) { last = now; render(r); }
            });
            obs.observe(box, { childList: true, subtree: true });
          })(root);
        }
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();